import queryString from 'qs';
import moment from 'moment';

const getResyncDataRequest = (payload) => {
    const [startDate, endDate] = payload?.sellout_date ?? [];
    const data = {
        group: payload?.group?.name ?? null,
        customer_id: payload?.customer?.id ?? null,
        start_date: startDate
            ? moment(startDate?.format()).format('YYYY-MM-DD')
            : moment().startOf('month').format('YYYY-MM-DD'),
        end_date: endDate ? moment(endDate?.format()).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
    };

    return queryString.stringify(data, { skipNulls: true });
};

export default getResyncDataRequest;
